
module Factive.Core {  
    "use strict"
    import Signal = Factive.Core.Signal.Signal;
    
    export class Panel extends PIXI.Container {
        public signal: Signal;
        protected _data: any;
        protected _name: any;
        protected _dc: Factive.Core.DependenciesContainer;
        protected _eventBus: EventBus;
        protected _assetScale: number;
        protected _aspectRatio: string;

        public get scrimVisible(): boolean {
            return true;
        }

        public get scrimAlpha(): number {
            return 1;
        }

        constructor(dc:DependenciesContainer, name:any){
            "use strict";
            super();
            this._name = name;
            this._dc = dc;
            this._eventBus = this._dc.get("EventBus");
            this._assetScale = this._dc.get("AssetScale");

            this.signal = new Signal();
        };


        public get panelName():any
        {
            return this._name;
        }
        protected build() {
            "use strict";
        };

        public reset() {
            "use strict";
            this._data = null;
        };

        public initialize(aspectRatio, data) {
            "use strict";
            this._aspectRatio = aspectRatio;
            this._data = data;
            this.build();
        };

        public resize(aspectRatio: string) {
            this._aspectRatio = aspectRatio;
            "use strict";
        };

        public changeAspectRatio() {
            "use strict";
            //this.reset();
            //this.build();
        };

        public open() {
            "use strict";
        };

        public onOpened() {
            "use strict";
            this.signal.dispatch(this,'opened',this._name);
        };


        public hide() {
            "use strict";
            this.onHided();
        };

        protected onHided() {
            "use strict";
            this.signal.dispatch(this,'hided',this._name);
        };

        protected sendEvent(type:string,topic:string,data?:Object):void
        {
            this._eventBus.dispatch(type,topic,{name:this._name,data:data});
        };

        public destroy() {
            "use strict";
            this.reset();
            this.signal.removeAll();
            this.signal = null;
            this._dc = null;
            this._eventBus = null;
            this._name = null;
        };
    }
}



// WEBPACK FOOTER //
// src/typescript/Core/Panel/Panel.ts